import deleteAddresses from "./deleteAddresses";
import bindAddresses from "./bindAddresses";

const checkAddresses = async (savedVoting, updatedVoting, addressesTree) => {
	const savedAddressesKeys = Object.keys(savedVoting.addresses);
	const updatedAddressesKeys = updatedVoting.addresses
		.map((value, key) => {
			if (value) {
				return key;
			}
		})
		.filter((key) => typeof key !== "undefined");
	if (
		savedAddressesKeys.length &&
		savedAddressesKeys.length === updatedAddressesKeys.length &&
		savedAddressesKeys.every((addressKey) => {
			return (
				savedVoting.addresses[addressKey] ===
				updatedVoting.addresses[addressKey]
			);
		})
	) {
		return;
	}
	await deleteAddresses(savedVoting.binds);
	await bindAddresses(updatedVoting.addresses, addressesTree, savedVoting.id);
};

export default checkAddresses;
